<template>

    <div :class="[video_full_width ? 'w-full max-w-screen-lg' : 'w-full md:w-4/5 max-w-screen-lg',
    is_visitor ? '-mt-20' : '',
        , 'transition-all duration-200']">
        <!-- style="max-width: 836px;" -->

        <div class="mb-0 mt-4 md:mt-0 mx-auto" v-if="!video_loaded && !can_watch_raw">
            <div class="video-item">
                <div
                    :class="['rounded-none sm:rounded-lg video-box flex relative overflow-hidden pb-16/9 mx shadow-md bg-gray-900 text-white']">

                    <div class="flex flex-col justify-center">
                        <div class="absolute h-full w-full pt-16/9" v-if="transcoding_error">
                            <p class="text-center -mt-16 text-sm font-normal">⚠️ There was a processing error.</p>
                            <p class="text-center mt-8" v-if="video.id >= 8681">
                                <a :href="'https://app.' + domain + '/download/' + video.uuid" target="_blank"
                                    title="Open the original file in a new tab"
                                    class="text-blue-200 hover:underline">Click here to download the original video
                                    file.</a>
                            </p>
                        </div>

                        <div class="absolute h-full w-full pt-16/9" v-else-if="video_error">
                            <p class="text-center -mt-16">⚠️ We encountered an error while loading your recording.
                                Please wait a moment and refresh the page.</p>
                        </div>

                        <div class="absolute h-full w-full pt-16/9 text-sm" v-else>
                            <p class="text-center -mt-16">Your recording is being processed…</p>
                            <p class="text-center">
                                <spinner class="mx-auto h-8 w-8 text-white my-4"></spinner>
                            </p>
                            <p class="text-center">It will be ready soon.</p>
                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="mb-0 mt-4 md:mt-0 mx-auto" v-else-if="video_loaded || can_watch_raw">
            <video-share-player :the_video="localVideo" :the_team_slug="the_team_slug" :team_admins="team_admins"
                :is_godview="is_godview" :is_visitor="is_visitor" :team_owner_email="team_owner_email"
                :datacenter="datacenter" :video_full_width="video_full_width" :can_watch_raw="can_watch_raw"
                :trim_offset="trim_offset" @playable="setCanPlay" :key="'player-' + force_fresh" :video_gif="video_gif"
                :video_thumb="video_thumb" @play_started="not_played_yet = false" />
        </div>

        <div class="mb-0 mt-4 md:mt-0 mx-auto" v-if="false">
            <video-share-player :the_video="localVideo" :the_team_slug="the_team_slug" :team_admins="team_admins"
                :is_godview="is_godview" :is_visitor="is_visitor" :team_owner_email="team_owner_email"
                :datacenter="datacenter" :video_full_width="video_full_width" />
        </div>

        <div v-if="video_loaded || can_watch_raw">
            <video-share-title :the_video="video" :the_team_slug="the_team_slug" :is_visitor="is_visitor"
                :teamtags="all_team_tags" :plan_secure_sharing="plan_secure_sharing" :pane_size="pane_size" :way="way"
                :folders="folders" :otherFolders="otherFolders" :video_loaded="video_loaded" />
        </div>

        <div v-else-if="!transcoding_error && !video_error && !can_watch_raw">
            <video-share-title-skeleton :the_video="video" :is_visitor="is_visitor" :can_watch_raw="can_watch_raw" />
        </div>

    </div>


</template>



<script>

import VideoSharePlayer from '@/Components/Video/VideoSharePlayer.vue';
import Spinner from '@/Components/UI/Spinner'
import VideoShareTitle from '@/Components/Video/VideoShareTitle.vue';
import VideoShareTitleSkeleton from '@/Components/UI/VideoShareTitleSkeleton.vue';
import { LinkIcon } from "@heroicons/vue/20/solid";
import moment from 'moment-timezone';


export default {

    props: ['video', 'the_team_slug', 'is_godview', 'is_visitor',
        'teamtags', 'team_owner_email', 'team_admins', 'datacenter',
        'plan_secure_sharing', 'video_loaded', 'video_error', 'transcoding_error',
        'video_full_width', 'pane_size', 'way', 'folders', 'otherFolders', 'video_gif', 'video_thumb'],

    components: {
        VideoSharePlayer, Spinner, VideoShareTitle, LinkIcon, VideoShareTitleSkeleton
    },

    watch: {
        video: {
            handler(newVal) {
                if (newVal && newVal.video_file) {
                    if (!this.can_watch_raw || !this.can_play || this.not_played_yet) {
                        this.trim_offset = null;
                        this.localVideo = newVal;
                        this.force_fresh++
                    }
                }
            },
            deep: true
        }
    },

    created: function () {


        if (this.teamtags) {
            this.all_team_tags = this.teamtags;
        }



        if (this.video && this.video.metadata) {

            this.moment = moment;
            if (this.video.start_timestamp && this.video.stop_timestamp) {
                this.video_initial_duration = Math.round(this.moment(this.video.stop_timestamp).diff(this.moment(this.video.start_timestamp)) / 1000);
            }

            let metadata = JSON.parse(this.video.metadata);
            if (!this.video.video_file) {
                // 0WIB9cSfze52hSxGzetFdCfyC8PPBTe1.mp4
                const excluded_extensions = ['.mkv', '.mov']
                const extension = this.getVideoExtension(this.video.original_filename)
                if (this.video.uploaded == 1 || excluded_extensions.includes(extension)) {
                    this.can_watch_raw = false;
                } else if (metadata?.trim_start !== null || metadata?.trim_end !== null) {
                    this.trim_offset = {
                        start: 0,
                        end: 0
                    }
                    if (metadata.trim_start !== null) {
                        this.trim_offset.start = Math.max(0, Math.ceil(metadata.trim_start))
                    }
                    if (metadata.trim_end !== null) {
                        // console.log("metadata.trim_end", metadata.trim_end, this.video_initial_duration)
                        this.trim_offset.end = Math.max(0, Math.floor(metadata.trim_end))
                    }
                    this.can_watch_raw = true;
                    // this.can_watch_raw = false;
                }
            }
        }

        this.localVideo = this.video

    },

    beforeUnmount() {
    },

    data() {
        return {
            //video: this.the_video,
            // video_loaded: false,
            // transcoding_error: false,
            all_team_tags: [],
            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
            app_name: this.$page.props.app_name,
            can_watch_raw: true,
            localVideo: null,
            can_play: true,
            force_fresh: 0,
            video_initial_duration: 0,
            not_played_yet: true,
            trim_offset: null
            // test: false
        }
    },

    mounted: function () {
        //console.log("team_admins:", this.team_admins);
        // setInterval(() => {
        //     this.test = !this.test
        // }, 2000)
    },

    methods: {
        setCanPlay(can_play) {
            this.can_play = can_play
        },
        getVideoExtension(url) {
            try {
                const pathname = new URL(url).pathname; // e.g. /videos/e4bf56a2/2034-399sotrtna9_1678375829.mkv
                const filename = pathname.split('/').pop(); // e.g. 2034-399sotrtna9_1678375829.mkv
                const ext = filename.includes('.') ? '.' + filename.split('.').pop() : null;
                return ext;
            } catch (e) {
                console.error('Invalid URL', e);
                return null;
            }
        }

    },

    computed: {

    }

}

</script>
